import React from "react";
import CustomMenu from "../../../components/Menu";
import CustomMenuItem from "../../../components/Menu/CustomMenuItem";
import { Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { setAssignedTask } from "../../../redux/plannerFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectTaskCount } from "../../../redux/plannerFilterSlice";

function AssignedToMeHeading({
  filter,
  anchorEl,
  setFilter,
  handleClose,
  handleOpen,
}) {
  const dispatch = useDispatch();
  const taskCount = useSelector(selectTaskCount);
  return (
    <div className="assign-to-me-header d-flex justify-content-space-between align-items-center">
      <Typography className="assign-to-me-title">Assigned to Me</Typography>
      <div
        className="filter-select d-flex align-items-center"
        onClick={(e) => {
          e.stopPropagation();
          handleOpen(e);
        }}
      >
        <span>{filter}</span>
        <div className="d-flex align-items-center">
          <span className="coloumn-header-length">{taskCount}</span>
          <KeyboardArrowDownIcon className="cursor-pointer" />
        </div>
      </div>
      <CustomMenu
        anchorEl={anchorEl}
        open={!!anchorEl}
        handleClose={handleClose}
      >
        {[
          {
            label: "All",
            value: "All",
          },
          {
            label: "Mine",
            value: "Mine",
          },
          {
            label: "Quick Tasks",
            value: "Quick Tasks",
          },
          {
            label: "Watching",
            value: "Watching",
          },
        ].map((item) => (
          <CustomMenuItem
            onClick={(event) => {
              event.stopPropagation();
              setFilter(item.value);
              dispatch(setAssignedTask(item.value));
              handleClose();
            }}
          >
            <label className="custom-checkbox">
              <input
                type="checkbox"
                id={`board-list-my-task-checkbox-all-board`}
                checked={filter === item.value}
              />
              <span className="checkmark"></span>
              {item.label}
            </label>
          </CustomMenuItem>
        ))}
      </CustomMenu>
    </div>
  );
}

export default AssignedToMeHeading;
